import { useTranslation } from 'next-i18next';
import { useCallback, useContext } from 'react';
import styled from 'styled-components';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';

interface SaleTypeProps {
  saleTypes: {
    name: 'all' | 'developer_sale' | 'resale';
    value: 'all' | 'developer_sale' | 'resale';
  }[];
  handleTabChange: (saleType: 'all' | 'developer_sale' | 'resale') => void;
}

const SaleTypeTabs = ({ saleTypes, handleTabChange }: SaleTypeProps) => {
  const { t } = useTranslation();

  const { searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;

  const isTabSelected = useCallback(
    (saleType: 'all' | 'developer_sale' | 'resale') => {
      const saleTypeFilters = searchFiltersState.searchFilters.sale_type;

      if (saleType === 'all') {
        return (
          saleTypeFilters.length === 0 ||
          (saleTypeFilters.includes('developer_sale') &&
            saleTypeFilters.includes('resale') &&
            saleTypeFilters.length === 2)
        );
      } else {
        return (
          saleTypeFilters.includes(saleType) && saleTypeFilters.length === 1
        );
      }
    },
    [searchFiltersState.searchFilters.sale_type]
  );

  return (
    <Container>
      {saleTypes.map(saleType => {
        return (
          <SaleTab
            key={saleType.name}
            className={`sale-type-tab ${
              isTabSelected(saleType.value) ? 'active' : ''
            }`}
            onClick={() => handleTabChange(saleType.value)}
          >
            {t(saleType.name, { ns: 'common' })}
          </SaleTab>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const SaleTab = styled.button`
  padding: 8px 16px;
  background-color: transparent;
  border: 1px solid #dfdcdc;
  cursor: pointer;
  font-size: 17px;
  color: #697586;
  border-radius: 360px;
  line-height: 150%;
  font-family: materialMedium;
  &.active {
    background-color: #015c9a;
    border: none;
    color: ${props => props.theme.light.colors.white};
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export default SaleTypeTabs;
